// export const OrderApi = {

//   SaveNuctracOrder: 'otc/save',
//   ExecuteBillingJob: 'otc/monthlybilling'
// }

// export const MiscApi = {
//   Settings: '/settings',
//   Log: '/log',
//   RelayUrl: '/relayurl',
//   Config: '/config',
// };

// export const AuthApi = {
//   Authenticate: 'authenticate',
//   Password: {
//     ResetEmail: 'password/forgot/email',
//     Reset: 'password/reset',
//     Update: 'password/change',
//   },
//   Token: {
//     Verify: 'token/verify',
//   },
//   Recovery: {
//     Answer: 'recovery/answer',
//     Change: 'recovery/question/change',
//     Questions: 'recovery/questions',
//     UserDetails: 'recovery/userdetails',
//   },
//   Account: {
//     UnlockEmail: 'unlock/email',
//     Setup: 'setup/useraccount',
//   },
// };

// export const OktaApi = {
//   OktaSession: '/api/v1/sessions/me'
// };

// export const DocumentRepositoryApi = {
//   moveInsideDocumentRepo: "/api/document/movedocument"
// }

// export const ConfigApi = {};

// export const UserApi = {
//   GetDetails: '/kinrayAdminUserDetails',
// };



export const TimeOutApi = {
  DEFAULT_TIME_OUT: 20000,
};

// export const LoginApi = {
//   ValidateSession: '/validate-session',
//   UNLOCK_USER_RESET_SECURITY_QUESTION: '/unlock/email',
//   USER_CREATE: '/user/create',
// };
